<template>
  <div>
    <v-card elevation="0" class="text-center">
            <v-toolbar color="#ef6b01">
            <v-btn icon dark @click="atras"><font-awesome-icon style="font-size:23px" icon="arrow-left"/></v-btn>
            <v-card-title style="color:white" class="text-truncate text-center">Detalle de compra</v-card-title>
        </v-toolbar>
        <v-card-text class="text-center mb-15 confirmar-orden-content">
             <DetalleCompraTabla />
        </v-card-text>
         <!--FOOTER---------------->
        <v-footer color="#ef6b01" padless fixed outlined class="mt-5" style="height: 57px;" rounded="0">
            <v-row justify="center" no-gutters>
                <v-col cols="4">
                </v-col>
                <v-col cols="4" class="text-center">
                    <v-btn style="bottom: 23px;" fab color="#ef6b01" elevation="20" @click="irVentas" class="my-2"><font-awesome-icon style="font-size:25px;color: white" icon="plus"/></v-btn>
                </v-col>
                <v-col cols="4">
                </v-col>
            </v-row>
        </v-footer>
    </v-card>
  </div>
</template>

<script>
import DetalleCompraTabla from '../components/DetalleCompraTabla.vue'
export default {
    name:'DetalleCompra',
    components: { DetalleCompraTabla },
    methods:{
        atras(){
            this.$router.go(-1)
        },
        irVentas(){
            this.$router.push({name: 'Home'});
        }
    }
}
</script>

<style>
.confirmar-orden-content {
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
}
</style>
